<script setup>
import {watch, ref, defineEmits} from "vue";
import {useI18n} from "vue-i18n";

const props = defineProps({
    client: {
        type: Object,
        required: true
    },
    listContracts: {
        type: Array,
        required: true
    }
})

const selectedContract = ref(null);
const emit = defineEmits(['update:contract']);
const { t } = useI18n();

watch(() => props.listContracts, (val) => {
    if (val?.length) {
        selectedContract.value = val[0].id;
    }
}, { immediate: true });

watch(selectedContract, (val) => {
    const contract = props.listContracts.find(c => c.id === val);
    if (contract) {
        emit('update:contract', contract);
    }
});

</script>



<template>
    <div class="info">
        <div class="name-row">
            <h3>{{ client.display_name }}</h3>
            <span class="status">{{ client.status ? t("common.labels.active") : t("common.labels.inactive") }}</span>
        </div>

        <p class="text-black detail">
            <strong>{{ t("components.customers.index.document") }}:</strong>
            {{ client.doc_identity }}
        </p>
        <div class="d-md-inline-flex ga-10 my-0 py-0">
            <p class="text-black detail">
                <strong>{{ t("components.customers.index.contract") }}:</strong>
            </p>
            <v-select
                v-model="selectedContract"
                :items="listContracts?.map(opt => ({
                title: opt.number,
                value: opt.id
            }))"
                class="small-select"
                item-title="title"
                item-value="value"
            >
            </v-select>
            <span> <v-icon>mdi-map-marker</v-icon> {{ client?.address?.city?.name }} / {{ client?.address?.city?.state }} </span>
        </div>

    </div>
</template>

<style scoped>
.info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.name-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.name-row h3 {
    margin: 0;
    font-size: 18px;
}

.status {
    font-size: 12px;
    background: #d1fae5;
    color: #065f46;
    padding: 2px 8px;
    border-radius: 6px;
    font-weight: 600;
}

.detail {
    margin: 2px 0;
    font-size: 14px;
    color: #374151;
}

@media (max-width: 768px) {
    .name-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }

    .detail {
        width: 100%;
    }

    .status {
        align-self: flex-start;
    }
}
</style>
